// @mui
import { styled, alpha } from "@mui/material/styles";
import { Badge, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Box } from "@shopify/polaris";

export function MainStyle({ children }) {
  return (
    <Box
      as="main"
      paddingBlockStart="24px"
      paddingBlockEnd="96px"
      width="100%"
      sx={{
        flexGrow: 1,
      }}
    >
      {children}
    </Box>
  );
}

export const ListItemStyle = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== "active" && prop !== "subItem",
})(({ active, theme, subItem = false }) => ({
  ...theme.typography.body2,
  position: "relative",
  textTransform: "capitalize",
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
  fontWeight: theme.typography.fontWeightMedium,
  justifyContent: "center",
  // active
  ...(active && {
    color: theme.palette.primary.main,
  }),

  [theme.breakpoints.up("lg")]: {
    ...(active && {
      // color: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    }),
  },
}));

export const ListItemTextStyle = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== "isCollapse" && prop !== "active",
})(({ isCollapse, theme, active }) => ({
  color: active ? theme.palette.primary.dark : theme.palette.text.secondary,

  "& > span": {
    fontWeight: theme.typography.fontWeightMedium,
  },

  whiteSpace: "nowrap",
  transition: theme.transitions.create(["width", "opacity", "margin-left"], {
    duration: theme.transitions.duration.shorter,
  }),

  [theme.breakpoints.up("lg")]: {
    marginLeft: 0,
  },

  ...(isCollapse && {
    marginLeft: 0,
    width: 0,
    opacity: 0,
  }),
}));

export const CollapseIconBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isCollapse",
})(({ isCollapse, theme }) => ({
  height: 24,

  "& > svg": {
    height: 24,
  },

  marginLeft: 36,
  transition: theme.transitions.create(["width", "opacity", "margin-left"], {
    duration: theme.transitions.duration.shorter,
  }),
  ...(isCollapse && {
    marginLeft: 0,
    width: 0,
    opacity: 0,
  }),
}));

export const ListItemIconStyle = styled(ListItemIcon)({
  width: 24,
  height: 24,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& svg": { width: "100%", height: "100%" },
});

export const StyledBadge = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    height: "14px",
    minWidth: "14px",
    fontSize: "0.7rem",
  },
}));
